import React from "react";
import { Plus, X } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import ImageUpload from "../common/ImageUpload";

const BannerForm = ({ data, onChange, submitted }) => {
  const tools = data?.tools || [];

  const handleToolChange = (index, value) => {
    onChange((prev) => {
      const newTools = [...(prev.tools || [])];
      newTools[index] = value;
      return { ...prev, tools: newTools };
    });
  };

  const addTool = () => {
    onChange((prev) => ({ ...prev, tools: [...(prev.tools || []), ""] }));
  };

  const removeTool = (index) => {
    onChange((prev) => ({
      ...prev,
      tools: (prev.tools || []).filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Banner Title <span className="text-red-500">*</span></Label>
          <Input
            value={data.title}
            className={(!data.title && submitted) ? "border-red-500 focus-visible:ring-red-500" : ""}
            onChange={(e) =>
              onChange((prev) => ({ ...prev, title: e.target.value }))
            }
            placeholder="e.g. Revolutionizing Digital Commerce"
          />
        </div>
        <div className="space-y-2">
          <Label>Banner Subtitle <span className="text-red-500">*</span></Label>
          <Input
            value={data.sub_title}
            className={(!data.sub_title && submitted) ? "border-red-500 focus-visible:ring-red-500" : ""}
            onChange={(e) =>
              onChange((prev) => ({ ...prev, sub_title: e.target.value }))
            }
            placeholder="Short catchy subtitle"
          />
        </div>
      </div>

      <div className={(!data.image && submitted) ? "rounded-lg border-2 border-red-500 p-1" : ""}>
        <ImageUpload
          label={<span>Banner Image <span className="font-normal text-xs text-gray-400">(783 × 591 px) <span className="text-red-500">*</span></span></span>}
          value={data.image}
          onChange={(url) => onChange((prev) => ({ ...prev, image: url }))}
        />
      </div>

      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <Label>Tech Stack Tools (Icons) <span className="text-red-500">*</span></Label>
          <button
            type="button"
            onClick={addTool}
            className="text-primary text-xs font-semibold hover:underline"
          >
            + Add Tool
          </button>
        </div>

        {tools.length === 0 && submitted && (
          <p className="text-xs text-red-500 mt-1">Please add at least one tech tool.</p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {tools.map((tool, index) => (
            <div
              key={index}
              className={`space-y-2 border p-3 rounded-xl bg-slate-50/30 relative ${(!tool && submitted) ? "border-red-500" : "border-slate-200"}`}
            >
              <button
                type="button"
                onClick={() => removeTool(index)}
                className="absolute top-2 right-2 p-1 text-red-500 hover:bg-red-50 rounded-full z-10"
              >
                <X size={14} />
              </button>
              <ImageUpload
                value={tool}
                onChange={(url) => handleToolChange(index, url)}
                className="min-h-0"
              />
            </div>
          ))}
        </div>

        {tools.length > 0 && (
          <button
            type="button"
            onClick={addTool}
            className="w-full py-3 border-2 border-dashed border-slate-200 rounded-xl text-slate-400 hover:border-primary/50 hover:text-primary transition-all flex items-center justify-center gap-2 font-medium mt-2"
          >
            <Plus size={16} /> Add Another Tool
          </button>
        )}
      </div>
    </div>
  );
};

export default BannerForm;
